/** @jsxImportSource @emotion/react */
import React from "react";
import ReactModal from "react-modal";
import SwitchNetworkIcon from "../../../../img/icon-switch_network.svg?react";
import { NetworkRow } from "./NetworkRow";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { MODAL_SELECTORS } from "../modalSelectors";
import { ModalContent } from "../../../general/ModalContent/ModalContent";
import {
  ModalContentContainer,
  ModalMainContentContainer,
} from "../RegionRestrictedModal/RegionRestrictedModal";
import { css } from "@emotion/react";
import { Text } from "../../../general/Text";
import { SUPPORTED_CHAINS } from "config/chains";

export const UnsupportedNetwork: React.FC = () => {
  const modalSelector = GlobalStore.useState(s => s.modalSelector);

  return (
    <>
      <ReactModal
        isOpen={modalSelector === MODAL_SELECTORS.UNSUPPORTED_NETWORK}
        className={`react-modal`}
        style={{
          content: {
            margin: "0 auto",
          },
        }}
      >
        <ModalContentContainer>
          <ModalContent backgroundColor="alt">
            <ModalMainContentContainer>
              <SwitchNetworkIcon />
              <Text
                textStyle="Title"
                size="Medium"
                textCss={css`
                  text-align: center;
                `}
              >
                Switch Network
              </Text>
              <Text
                textStyle="Paragraph"
                size="Large"
                textCss={css`
                  width: 270px;
                  margin: auto;
                  text-align: center;
                `}
              >
                To use Bebop please switch to a supported network
              </Text>
              {SUPPORTED_CHAINS.map(network => {
                const Icon = network.icon;
                return (
                  <NetworkRow
                    key={network.id}
                    networkName={network.displayName}
                    icon={<Icon width={22} height={22} color={network.iconColor} />}
                    networkId={network.id}
                  />
                );
              })}
            </ModalMainContentContainer>
          </ModalContent>
        </ModalContentContainer>
      </ReactModal>
    </>
  );
};
